import { render } from "./BacklogSprint.vue?vue&type=template&id=bca6c744&scoped=true"
import script from "./BacklogSprint.vue?vue&type=script&lang=js"
export * from "./BacklogSprint.vue?vue&type=script&lang=js"

import "./BacklogSprint.vue?vue&type=style&index=0&id=bca6c744&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca6c744"]])

export default __exports__